const CreateHwRequest = {
     idProfilCbt: null,
     namaProfil: null,
     idSekolah: null,
     idGuru: null,
     idKurikulum: null,
     idKelas: null,
     namaKelas: null,
     kodeTipeCbt: null,
     kodeSubTipeCbt: null,
     idSubProfilCbt: null,
     namaSubProfil: null,
     jumlahSoal: null,
     idMataPelajaran: null,
     idTematik: null,
     prosentaseEssay: null,
     ketuntasanMinimum: null,
     random: null,
     cbtOwner: null,
     idAdmin: null,
     durasi: null,
     pointBenar: null,
     pointSalah: null,
     pointTakTerjawab: null,
}

export default CreateHwRequest